import { z } from 'zod';
import {
  InternalNetworkAssessmentProgressCredentialSchema,
  InternalNetworkAssessmentProgressFootholdSchema,
  InternalNetworkAssessmentProgressGoalSchema,
} from './internal-network-assessment-foothold.schema';

export const INTERNAL_NETWORK_DOMAIN_COMPROMISE_IMPACT = 'DOMAIN_COMPROMISE';

export const INTERNAL_NETWORK_V2_MAX_ATTEMPTED_PATHS = 3;

export const InternalNetworkAssessmentDerivedViewSchema = z.object({
  networkId: z.string(),
  assessmentId: z.string(),
  generatedAt: z.iso.datetime(),
  footholds: z.array(InternalNetworkAssessmentProgressFootholdSchema),
  ownedActors: z.array(z.string()),
  credentialsGained: z.array(InternalNetworkAssessmentProgressCredentialSchema),
  hostsReached: z.array(z.string()),
  servicesDiscovered: z.array(z.string()),
  impactsAchieved: z.array(z.string()),
  occupiedHopFingerprints: z.array(z.string()),
  attemptedPathKeys: z.array(z.string()),
  attemptedPathCount: z.number().int().nonnegative(),
  goals: z.array(InternalNetworkAssessmentProgressGoalSchema),
  remainingGoalKeys: z.array(z.string()),
  reachedCrownJewel: z.string().nullable(),
  completed: z.boolean(),
  goalReached: z.boolean(),
});

export type InternalNetworkAssessmentDerivedViewDto = z.infer<
  typeof InternalNetworkAssessmentDerivedViewSchema
>;
